<template>
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Round checkbox icon</title>
    <circle cx="8" cy="8" r="7.5" class="text-primary fill-current stroke-current" />
    <path
      d="M6.49918 10.1039L4.34692 7.95164L3.61401 8.67938L6.49918 11.5645L12.6927 5.37099L11.965 4.64325L6.49918 10.1039Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'KIconCheck'
}
</script>
